import { logGlassbox, buildGlassboxPayload } from '../glassbox.client.logger';

function _log(schemaId, eventType, eventName, params) {
  return logGlassbox(buildGlassboxPayload('Analytics', schemaId, 'PreziGram', eventType, eventName, params));
}

export function logAddCollaboratorFailed(params) {
  return _log(17277, 'AddCollaboratorFailed', 'AddCollaboratorFailedWebPreziGram', params);
}
export function logAddCollaborator(params) {
  return _log(17267, 'AddCollaborator', 'AddCollaboratorWebPreziGram', params);
}
export function logAddGramLayout(params) {
  return _log(18789, 'AddGramLayout', 'AddGramLayoutWebPreziGram', params);
}
export function logAdjustImageFilter(params) {
  return _log(16547, 'AdjustImageFilter', 'AdjustImageFilterWebPreziGram', params);
}
export function logApplyBrandkit(params) {
  return _log(18954, 'ApplyBrandkit', 'ApplyBrandkitWebPreziGram', params);
}
export function logBackFromTemplateChooser() {
  return _log(16392, 'BackFromTemplateChooser', 'BackFromTemplateChooserWebPreziGram');
}
export function logChangeGramCalloutBehaviour(params) {
  return _log(16538, 'ChangeGramCalloutBehaviour', 'ChangeGramCalloutBehaviourWebPreziGram', params);
}
export function logChangeGramCalloutPosition(params) {
  return _log(16542, 'ChangeGramCalloutPosition', 'ChangeGramCalloutPositionWebPreziGram', params);
}
export function logChangeOrientation(params) {
  return _log(17570, 'ChangeOrientation', 'ChangeOrientationWebPreziGram', params);
}
export function logChangeTeamAccess(params) {
  return _log(17287, 'ChangeTeamAccess', 'ChangeTeamAccessWebPreziGram', params);
}
export function logChangedAnalyticsTracking(params) {
  return _log(17158, 'ChangedAnalyticsTracking', 'ChangedAnalyticsTrackingWebPreziGram', params);
}
export function logChangedViewLinkName(params) {
  return _log(17144, 'ChangedViewLinkName', 'ChangedViewLinkNameWebPreziGram', params);
}
export function logChangedViewerIdentification(params) {
  return _log(17169, 'ChangedViewerIdentification', 'ChangedViewerIdentificationWebPreziGram', params);
}
export function logClickCta(params) {
  return _log(17378, 'ClickCta', 'ClickCtaWebPreziGram', params);
}
export function logClickExternalLink(params) {
  return _log(17613, 'ClickExternalLink', 'ClickExternalLinkWebPreziGram', params);
}
export function logClickOnWatermark(params) {
  return _log(18143, 'ClickOnWatermark', 'ClickOnWatermarkWebPreziGram', params);
}
export function logClickUseThisTemplate(params) {
  return _log(16300, 'ClickUseThisTemplate', 'ClickUseThisTemplateWebPreziGram', params);
}
export function logCloseCollaboratorsDialog(params) {
  return _log(17290, 'CloseCollaboratorsDialog', 'CloseCollaboratorsDialogWebPreziGram', params);
}
export function logClosePrivacyDialog(params) {
  return _log(17333, 'ClosePrivacyDialog', 'ClosePrivacyDialogWebPreziGram', params);
}
export function logCloseWatermarkSidebar(params) {
  return _log(18152, 'CloseWatermarkSidebar', 'CloseWatermarkSidebarWebPreziGram', params);
}
export function logConfigureWatermark(params) {
  return _log(18158, 'ConfigureWatermark', 'ConfigureWatermarkWebPreziGram', params);
}
export function logContactSupport() {
  return _log(16719, 'ContactSupport', 'ContactSupportWebPreziGram');
}
export function logCopyPublishLink(params) {
  return _log(17355, 'CopyPublishLink', 'CopyPublishLinkWebPreziGram', params);
}
export function logCopyViewLink(params) {
  return _log(17135, 'CopyViewLink', 'CopyViewLinkWebPreziGram', params);
}
export function logCreateNewVideo(params) {
  return _log(18713, 'CreateNewVideo', 'CreateNewVideoWebPreziGram', params);
}
export function logCreatedFromCustomSize(params) {
  return _log(17451, 'CreatedFromCustomSize', 'CreatedFromCustomSizeWebPreziGram', params);
}
export function logCreatedFromTemplate(params) {
  return _log(17578, 'CreatedFromTemplate', 'CreatedFromTemplateWebPreziGram', params);
}
export function logCreatedViewLink(params) {
  return _log(17198, 'CreatedViewLink', 'CreatedViewLinkWebPreziGram', params);
}
export function logDeactivatedViewLink(params) {
  return _log(17178, 'DeactivatedViewLink', 'DeactivatedViewLinkWebPreziGram', params);
}
export function logDeleteObject(params) {
  return _log(18262, 'DeleteObject', 'DeleteObjectWebPreziGram', params);
}
export function logDownloadGramObject(params) {
  return _log(18194, 'DownloadGramObject', 'DownloadGramObjectWebPreziGram', params);
}
export function logDownloadGramProject(params) {
  return _log(18198, 'DownloadGramProject', 'DownloadGramProjectWebPreziGram', params);
}
export function logDownloadImage(params) {
  return _log(16739, 'DownloadImage', 'DownloadImageWebPreziGram', params);
}
export function logDragObject(params) {
  return _log(18268, 'DragObject', 'DragObjectWebPreziGram', params);
}
export function logGenerateGramAutoLayout(params) {
  return _log(16563, 'GenerateGramAutoLayout', 'GenerateGramAutoLayoutWebPreziGram', params);
}
export function logGroupObjects(params) {
  return _log(16600, 'GroupObjects', 'GroupObjectsWebPreziGram', params);
}
export function logInsertChart(params) {
  return _log(16597, 'InsertChart', 'InsertChartWebPreziGram', params);
}
export function logInsertConnector(params) {
  return _log(16526, 'InsertConnector', 'InsertConnectorWebPreziGram', params);
}
export function logInsertGramElement(params) {
  return _log(17685, 'InsertGramElement', 'InsertGramElementWebPreziGram', params);
}
export function logInsertImage(params) {
  return _log(18072, 'InsertImage', 'InsertImageWebPreziGram', params);
}
export function logInsertIntegration(params) {
  return _log(16522, 'InsertIntegration', 'InsertIntegrationWebPreziGram', params);
}
export function logInsertMap(params) {
  return _log(16535, 'InsertMap', 'InsertMapWebPreziGram', params);
}
export function logInsertMedia(params) {
  return _log(18717, 'InsertMedia', 'InsertMediaWebPreziGram', params);
}
export function logInsertShape(params) {
  return _log(16622, 'InsertShape', 'InsertShapeWebPreziGram', params);
}
export function logInsertTextbox(params) {
  return _log(16646, 'InsertTextbox', 'InsertTextboxWebPreziGram', params);
}
export function logInsertVideo(params) {
  return _log(18016, 'InsertVideo', 'InsertVideoWebPreziGram', params);
}
export function logLeaveFullScreen(params) {
  return _log(17403, 'LeaveFullScreen', 'LeaveFullScreenWebPreziGram', params);
}
export function logLikePublishPage(params) {
  return _log(17361, 'LikePublishPage', 'LikePublishPageWebPreziGram', params);
}
export function logLoadedEditor(params) {
  return _log(18994, 'LoadedEditor', 'LoadedEditorWebPreziGram', params);
}
export function logLoadedPalletsBrandkit(params) {
  return _log(18965, 'LoadedPalletsBrandkit', 'LoadedPalletsBrandkitWebPreziGram', params);
}
export function logLoadedPaywallDialog(params) {
  return _log(18494, 'LoadedPaywallDialog', 'LoadedPaywallDialogWebPreziGram', params);
}
export function logLoadedPublicPublishPage(params) {
  return _log(20263, 'LoadedPublicPublishPage', 'LoadedPublicPublishPageWebPreziGram', params);
}
export function logLoadedWatermarkSidebar(params) {
  return _log(18160, 'LoadedWatermarkSidebar', 'LoadedWatermarkSidebarWebPreziGram', params);
}
export function logModifyGramCallout(params) {
  return _log(16576, 'ModifyGramCallout', 'ModifyGramCalloutWebPreziGram', params);
}
export function logModifyGramPage(params) {
  return _log(16580, 'ModifyGramPage', 'ModifyGramPageWebPreziGram', params);
}
export function logModifyGramProject(params) {
  return _log(16582, 'ModifyGramProject', 'ModifyGramProjectWebPreziGram', params);
}
export function logModifyObjectAnimationSetting(params) {
  return _log(18286, 'ModifyObjectAnimationSetting', 'ModifyObjectAnimationSettingWebPreziGram', params);
}
export function logModifyObjectAnimationTrigger(params) {
  return _log(18290, 'ModifyObjectAnimationTrigger', 'ModifyObjectAnimationTriggerWebPreziGram', params);
}
export function logModifyObject(params) {
  return _log(18781, 'ModifyObject', 'ModifyObjectWebPreziGram', params);
}
export function logOpenCreateViewLinkDialog(params) {
  return _log(17207, 'OpenCreateViewLinkDialog', 'OpenCreateViewLinkDialogWebPreziGram', params);
}
export function logOpenLearnMoreBrandkit() {
  return _log(18901, 'OpenLearnMoreBrandkit', 'OpenLearnMoreBrandkitWebPreziGram');
}
export function logOpenObjectGramCallout(params) {
  return _log(16587, 'OpenObjectGramCallout', 'OpenObjectGramCalloutWebPreziGram', params);
}
export function logOpenSocialShare(params) {
  return _log(17098, 'OpenSocialShare', 'OpenSocialShareWebPreziGram', params);
}
export function logOpenTemplatePreview(params) {
  return _log(16484, 'OpenTemplatePreview', 'OpenTemplatePreviewWebPreziGram', params);
}
export function logOpenViewLinkDialog(params) {
  return _log(17187, 'OpenViewLinkDialog', 'OpenViewLinkDialogWebPreziGram', params);
}
export function logOpenWatermarkSidebar(params) {
  return _log(18176, 'OpenWatermarkSidebar', 'OpenWatermarkSidebarWebPreziGram', params);
}
export function logOpenWatermark(params) {
  return _log(18167, 'OpenWatermark', 'OpenWatermarkWebPreziGram', params);
}
export function logPasteObject(params) {
  return _log(18307, 'PasteObject', 'PasteObjectWebPreziGram', params);
}
export function logPresentInFullScreen(params) {
  return _log(16669, 'PresentInFullScreen', 'PresentInFullScreenWebPreziGram', params);
}
export function logRemoveGramCallout(params) {
  return _log(16590, 'RemoveGramCallout', 'RemoveGramCalloutWebPreziGram', params);
}
export function logRemoveGramLayout(params) {
  return _log(18786, 'RemoveGramLayout', 'RemoveGramLayoutWebPreziGram', params);
}
export function logResetImageFilter(params) {
  return _log(16550, 'ResetImageFilter', 'ResetImageFilterWebPreziGram', params);
}
export function logSelectImageFilterPreset(params) {
  return _log(16726, 'SelectImageFilterPreset', 'SelectImageFilterPresetWebPreziGram', params);
}
export function logSetPrivacy(params) {
  return _log(17595, 'SetPrivacy', 'SetPrivacyWebPreziGram', params);
}
export function logSharePublish(params) {
  return _log(17674, 'SharePublish', 'SharePublishWebPreziGram', params);
}
export function logShowGramOverflow(params) {
  return _log(18793, 'ShowGramOverflow', 'ShowGramOverflowWebPreziGram', params);
}
export function logUnlikePublishPage(params) {
  return _log(17375, 'UnlikePublishPage', 'UnlikePublishPageWebPreziGram', params);
}
export function logUpdateCollaborator(params) {
  return _log(17304, 'UpdateCollaborator', 'UpdateCollaboratorWebPreziGram', params);
}
export function logUpgradeToTeam(params) {
  return _log(18960, 'UpgradeToTeam', 'UpgradeToTeamWebPreziGram', params);
}
export function logViewProjectInWebView(params) {
  return _log(16735, 'ViewProjectInWebView', 'ViewProjectInWebViewWebPreziGram', params);
}